var faqsWidget= {
    accordion: function () {

        //$('.c-faqs-widget__list > .c-faqs-widget__item:eq(0) .c-faqs-widget__question').addClass('is-active').next().slideDown();

        $('.js-faqs-widget-question').click(function (j) {
            var dropDown = $(this).closest('.c-faqs-widget__item').find('.c-faqs-widget__answer');

            $(this).closest('.c-faqs-widget__list').find('.c-faqs-widget__answer').not(dropDown).slideUp();

            $('.js-faqs-widget-question').not(dropDown).attr('aria-expanded', 'false');

            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $(this).attr('aria-expanded' , 'false') 
            } else {
                $(this).closest('.c-faqs-widget__list').find('.js-faqs-widget-question.is-active').removeClass('is-active');
                $(this).addClass('is-active');
                $(this).attr('aria-expanded' , 'true') ;
            } 

            dropDown.stop(false, true).slideToggle();

            j.preventDefault();
        });

    }
}

$(function () {

    if ($('.c-faqs-widget').length) {
        faqsWidget.accordion();
    }
})